import React from "react";
import homebanner from "../../images/homebanner.png";
import btnarrow from "../../icons/btnarrow.png";
const HomeBanner = () => {
  return (
    <>
      <div className="bg-first pt-5 pb-5">
        <div className="container ">
          <div className="row">
            <div className="col-lg-6">
              <div className="homebannerleft">
                <h1>
                  Experience <br />
                  <span className="color-black">Modern Luxury</span> in <br />
                  Interior
                </h1>
                <p>"Elevate your space with our modern luxury furniture collection, blending sleek design with timeless elegance. Crafted from premium materials, each piece offers exceptional comfort and refined style. Perfect for creating bold, sophisticated interiors, our furniture combines form, function, and lasting quality for a truly luxurious living experience."</p>
                <button className="get-started mt-3 mb-4"> <img src={btnarrow} alt=""/><div className="">Get Started</div></button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="homebannerright d-flex justify-content-end">
                <img src={homebanner} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeBanner;
